export const formatTime = seconds => {
  if (seconds !== undefined) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return [h, m > 9 ? m : h ? '0' + m : m || '0', s > 9 ? s : '0' + s].filter(a => a).join(':');
  }
};

export const toLocal = date => {
  if (date !== undefined) {
    const local = new Date(date);
    const strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const d = local.getDate();
    const m = strArray[local.getMonth()];
    const y = local.getFullYear();
    return ' ' + m + '. ' + (d <= 9 ? '0' + d : d) + ', ' + y;
  }
};

export const escapeSelector = selector => {
  return selector.replace(/([\\\^\$\*\+\?\|\{\}\[\]\(\)\.\-\+])/g, '\\$1');
};

export const sanitizeId = title => {
  return escapeSelector(title.replace(/[^a-zA-Z0-9_-]/g, '-').toLowerCase());
};
